<template>
  <div v-loading='loading'>
    <div class="item">
      <label>客户名称</label>
      <div class="inputDiv">{{dataList.customer_name}}</div>
    </div>
    <div class="item">
      <label>申请日期</label>
      <div class="inputDiv">{{add_date}}</div>
    </div>
    <div class="item">
      <label>申请人</label>
      <div class="inputDiv">{{dataList.applicant}}</div>
    </div>
    <div class="item">
      <label>开票金额</label>
      <div class="inputDiv">{{dataList.invoice_amount}}</div>
    </div>
    <div class="item">
      <label><em class="stars">*</em>发票类型</label>
      <el-select v-model="uploadFileData.invoice_type" size='mini' filterable placeholder="请选择">
        <el-option v-for="(item,index) in invoiceTypeList" :key="index" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="item">
      <label><em class="stars">*</em>发票服务类型</label>
      <div class="inputDiv" :style="!dataList.service_type?'color:red':''">{{dataList.service_type?dataList.service_type:'发票服务类型不存在，请先进行配置！'}}</div>
    </div>
    <div class="item">
      <label>备注</label>
      <el-input class="input" v-model="uploadFileData.invoice_note" size='mini' placeholder="请输入备注"></el-input>
    </div>
    <div class="item">
      <label>收件人</label>
      <el-input class="input" v-model="uploadFileData.consignee" size='mini' placeholder="请输入收件人"></el-input>
    </div>
    <div class="item">
      <label>联系人</label>
      <el-input class="input" v-model="uploadFileData.contacts" size='mini' placeholder="请输入联系人"></el-input>
    </div>
    <div class="item">
      <label>联系方式</label>
      <el-input class="input" v-model="uploadFileData.contact_number" size='mini' placeholder="请输入联系方式"></el-input>
    </div>
    <div class="item">
      <label>邮寄地址</label>
      <el-input class="input" v-model="uploadFileData.mail_address" size='mini' placeholder="请输入邮寄地址"></el-input>
    </div>
    <div class="item">
      <label>开票说明</label>
      <el-input class="input" v-model="uploadFileData.note" size='mini' placeholder="请输入开票说明"></el-input>
    </div>
    <div class="line"></div>
    <div class="item">
      <label>名称</label>
      <div class="inputDiv">{{dataList.customer_name}}</div>
    </div>
    <div class="item">
      <label>税号</label>
      <div class="inputDiv">{{dataList.party_a_ein}}</div>
    </div>
    <div class="item">
      <label style="vertical-align: top;">地址/电话</label>
      <div class="inputDiv">{{dataList.party_a_address}}</div>
    </div>
    <div class="item">
      <label style="vertical-align: top;">银行/账号</label>
      <div class="inputDiv">{{dataList.party_a_account}}</div>
    </div>
    <div class="item">
      <add-file @file='(val)=>{uploadFileData.files=val}' :fileOtherList='[]' :uploadOtherFile='[]'></add-file>
    </div>
    <div slot="footer" style="text-align: center;margin-top:40px">
      <el-button type="primary" size='small' @click="submitUpload">提 交</el-button>
      <el-button size='small' @click="closeToast">取 消</el-button>
    </div>
  </div>
</template>
<script>
import addFile from '@/components/assembly/addFile'
export default {
  props: ['dataList'],
  components: { addFile },
  data () {
    return {
      invoiceType: '',
      invoiceTypeList: [{ name: '增值税专用发票', id: 1 }, { name: '增值税普通发票', id: 2 }],
      invoiceServiceType: '',
      note: '',
      dutyParagraph: '',
      phone: '',
      bank: '',
      add_date: '',//申请日期 当前日期
      userInfo: {},
      uploadFileData: {
        statements_id: this.dataList.id,
        invoice_type: '',
        service_type: this.dataList.service_type,
        invoice_note: '',
        consignee: '',
        contacts: '',
        contact_number: '',
        mail_address: '',
        note: '',
        files: [],
      },
      loading: false,
      fileList: [],
      pickerOptionsMonth: {
        disabledDate (time) {
          return time.getTime() > new Date('2021-03-31 00:00:00');
        },
      },
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    //当前日期
    var date = new Date();
    this.add_date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
  },
  mounted () {
  },
  methods: {
    closeToast () {
      this.$emit('closeToast')
    },
    submitUpload () {//上传
      if (this.uploadFileData.invoice_type == '') {
        this.$message({
          message: '请选择发票类型',
          type: 'warning'
        })
        return
      }
      if (!this.uploadFileData.service_type || this.uploadFileData.service_type == '') {
        this.$message({
          message: '发票服务类型不存在，请先进行配置！',
          type: 'warning'
        })
        return
      }
      if (this.uploadFileData.files.length <= 0) {
        this.$message({
          message: '请上传附件',
          type: 'success'
        })
        return;
      }
      this.loading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.customerInvoicesComplement_add, this.uploadFileData).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.$emit('updateList')
          this.$message({
            message: '上传成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$message({
          message: '上传失败',
          type: 'fail'
        })
        this.loading = false
      })
    },
    changeUpload (file, fileList) {
      this.fileList = fileList;
    },
    removeFile (file) {
      this.fileList = this.fileList.filter((v) => {
        return v.name + v.uid != file.name + file.uid
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.item {
  margin-bottom: 12px;
  margin-left: 60px;
  label {
    color: #202652;
    font-size: 14px;
    line-height: 20px;
    display: inline-block;
    width: 100px;
    .stars {
      color: red;
    }
  }
  .inputDiv {
    display: inline-block;
    color: #5e5f6b;
    font-size: 14px;
    line-height: 20px;
  }
  .input {
    width: 60%;
    display: inline-block;
  }
}
.line {
  width: 100%;
  height: 1px;
  background: #e6e6ef;
  margin-bottom: 20px;
}
.uploadFile {
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/BeforeApril/invoice/InvoiceFilling.vue